// @flow
import React from "react";

const ThemeContext = React.createContext<Object>({
  darkMode: true,
  fontSize: "normal",
  changeFontSize: () => {},
  toggleDarkMode: () => {},
});

export default ThemeContext;
